/**
 * Agents Management Page
 *
 * Wrapper for the Agent Management Dashboard
 */

import React from 'react'
import AgentManagementDashboard from '../../components/features/agents/AgentManagementDashboard'

export const Agents: React.FC = () => {
  return <AgentManagementDashboard />
}

export default Agents
